// extracted by mini-css-extract-plugin
module.exports = {"remove":"RemoveButton_remove__1wo9k","show":"RemoveButton_show__2giV3","hide":"RemoveButton_hide__bO5kM"};